import { render, staticRenderFns } from "./cartItems.vue?vue&type=template&id=b9a00a74&scoped=true&"
import script from "./cartItems.vue?vue&type=script&lang=js&"
export * from "./cartItems.vue?vue&type=script&lang=js&"
import style0 from "./cartItems.vue?vue&type=style&index=0&id=b9a00a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a00a74",
  null
  
)

export default component.exports